import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ApiMetaState = {
  shouldPersist: boolean
  persistedEndpointVersions?: Record<string, number>
}

const initialState: ApiMetaState = {
  shouldPersist: false,
}

const apiMetaSlice = createSlice({
  name: 'apiMeta',
  initialState,
  reducers: {
    setShouldPersist: (state, action: PayloadAction<boolean>) => {
      state.shouldPersist = action.payload
    },
    setPersistedEndpointVersions: (state, action: PayloadAction<Record<string, number>>) => {
      state.persistedEndpointVersions = action.payload
    },
  },
})

export const { setPersistedEndpointVersions, setShouldPersist } = apiMetaSlice.actions
export default apiMetaSlice.reducer
